import React, { useEffect, useState } from 'react'
import { Btn, CustomCard, PageHeader, Periodo, SelectEmpresas } from '../../../../components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Card } from 'primereact/card'
import { azul_claro, azul_escuro, black, laranja, pink, verde } from '../../../../assets/js/colors'
import { Cell, Legend, Pie, PieChart, ResponsiveContainer, Tooltip } from 'recharts'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { tableCellCentered } from '../../../../assets/js/styles'
import {
  parseToMysqlFormatWithTime00,
  parseToMysqlFormatWithTime23,
} from '../../../../services/util/date.service'
import { getOcorrenciaPorColaboradores } from '../../../../services/api/https/ordem-coleta/ordem-coleta.http'
import { showMessageBox } from '../../../../store/actions/system.actions'
import { errorHandler } from '../../../../services/util/error.service'
import { useOcorrenciaColaboradorContext } from '../../../../contexts/OrdemColetaContext'

// Constants
const COLORS = [
  '#0088FE',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#0088FE',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#0088FE',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
  '#0088FE',
  '#00C49F',
  '#FFBB28',
  '#FF8042',
]

const OcorrenciasPorColaboradores = ({ history, selectedTp, dispatch }) => {
  const context = useOcorrenciaColaboradorContext()

  // Hooks
  const [selectedEmpresa, setSelectedEmpresa] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [data, setData] = useState(null)
  const [periodo, setPeriodo] = useState({
    ...context.ocorrenciaColaboradorContext.selectedPeriodo,
  })

  useEffect(() => {
    async function fetchInfo() {
      try {
        const { dataInicial, dataFinal } = periodo
        const pInicial = parseToMysqlFormatWithTime00(dataInicial)
        const pFinal = parseToMysqlFormatWithTime23(dataFinal)
        const fetchedData = await getOcorrenciaPorColaboradores(
          selectedEmpresa,
          selectedTp,
          pInicial,
          pFinal,
        )
        setData(fetchedData)
        context.setOcorrenciaColaboradorContext(prevOcorrenciaColaboradorContext => ({
          ...prevOcorrenciaColaboradorContext,
          data: fetchedData,
        }))
      } catch (error) {
        dispatch(showMessageBox(null, errorHandler(error)))
      } finally {
        setIsLoading(false)
      }
    }
    isLoading && fetchInfo()
  }, [isLoading])

  useEffect(() => {
    if (context.ocorrenciaColaboradorContext.selectedEmpresa !== '') {
      setSelectedEmpresa(context.ocorrenciaColaboradorContext.selectedEmpresa)
      if (context.ocorrenciaColaboradorContext.data !== '')
        setData(context.ocorrenciaColaboradorContext.data)
    }
    setPeriodo(context.ocorrenciaColaboradorContext.selectedPeriodo)
  }, [])

  useEffect(() => {
    try {
      if (selectedEmpresa === '' && context.ocorrenciaColaboradorContext.selectedEmpresa === '')
        throw new Error('Selecione a Empresa Desejada')
      if (selectedTp === 0) throw new Error('Selecione o Operador Desejado')
      if (context.ocorrenciaColaboradorContext.data === '') setIsLoading(true)
    } catch (error) {
      dispatch(showMessageBox(null, errorHandler(error)))
    }
  }, [selectedTp, periodo])

  // Render
  return (
    <>
      <PageHeader>Ocorrências Por Colaborador</PageHeader>
      <div className="p-grid">
        <div className="p-col-12" style={{ marginTop: 8 }}>
          <Btn onClick={history.goBack}>Voltar</Btn>
        </div>
        <div className="p-col-3">
          <SelectEmpresas
            companyId={selectedEmpresa}
            onChange={empresa => {
              context.setOcorrenciaColaboradorContext(prevOcorrenciaColaboradorContext => ({
                ...prevOcorrenciaColaboradorContext,
                selectedEmpresa: empresa.id,
                data: '',
              }))
              setSelectedEmpresa(empresa.id)
            }}
          />
        </div>
        <div className="p-col-4">
          <Periodo
            isLoading={isLoading}
            periodoInicial={periodo.dataInicial}
            periodoFinal={periodo.dataFinal}
            onPesquisar={(dataInicial, dataFinal) => {
              context.setOcorrenciaColaboradorContext(prevOcorrenciaColaboradorContext => ({
                ...prevOcorrenciaColaboradorContext,
                selectedPeriodo: { dataInicial, dataFinal },
                data: '',
              }))
              setPeriodo({ dataInicial, dataFinal })
            }}
          />
        </div>
        <div className="p-col-12" style={{ marginTop: 16 }}>
          {!data ? (
            <p>Não existe informação para ser exibida</p>
          ) : (
            <div className="p-grid">
              <div className="p-col-4">
                <CustomOcorrenciasCard
                  value={data.qteSeparacoes}
                  title={'Qte de Separações'}
                  subTitle={'Quantidade de separações no período'}
                  barColor={black}
                />
              </div>
              <div className="p-col-4">
                <CustomOcorrenciasCard
                  value={data.qteCaixas}
                  title={'Qte de Caixas'}
                  subTitle={'Quantidade de Caixas Movimentadas'}
                  barColor={verde}
                />
              </div>
              <div className="p-col-4">
                <CustomOcorrenciasCard
                  value={data.peso}
                  title={'Peso'}
                  subTitle={'Peso Movimentado'}
                  barColor={laranja}
                />
              </div>
              <div className="p-col-4">
                <CustomOcorrenciasCard
                  value={data.qteSobras}
                  title={'Qte de Sobras'}
                  subTitle={'Quantidade de Sobras Apuradas (cx)'}
                  barColor={azul_escuro}
                />
              </div>
              <div className="p-col-4">
                <CustomOcorrenciasCard
                  value={data.qteOcorrencias}
                  title={'Qte de Ocorrências'}
                  subTitle={'Quantidade de Ocorrências Total'}
                  barColor={azul_claro}
                />
              </div>
              <div className="p-col-4">
                <CustomOcorrenciasCard
                  value={data.percentualOcorrencia}
                  title={'% de Ocorrência'}
                  subTitle={'Percentual de Ocorrências Total'}
                  barColor={pink}
                />
              </div>
              <div className="p-col-6">
                <DatatableEquipe
                  title={'Ocorrências Por Equipe de Separação'}
                  equipeColumnTitle={'Equipes'}
                  equipeData={data.equipeSeparacao}
                />
              </div>
              <div className="p-col-6">
                <DatatableEquipe
                  title={'Ocorrências Por Equipe de Entrega'}
                  equipeColumnTitle={'Motoristas'}
                  equipeData={data.equipeEntrega}
                />
              </div>
              <div className="p-col-6">
                <GraficoOcorrencias
                  title={'Ocorrências - Etapa Separação'}
                  ocorrencias={data.ocorrenciasEtapaSeparacaoGrafico}
                />
              </div>
              <div className="p-col-6">
                <GraficoOcorrencias
                  title={'Ocorrências - Etapa Entrega'}
                  ocorrencias={data.ocorrenciasEtapaEntregaGrafico}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  )
}

// Local Components
const CustomOcorrenciasCard = ({ title, subTitle, value, barColor }) => {
  return (
    <Card title={title} subTitle={subTitle} style={{ borderTop: `5px solid ${barColor}` }}>
      <h1 className="text-center">{value}</h1>
    </Card>
  )
}

const GraficoOcorrencias = ({ title, ocorrencias }) => {
  return (
    <CustomCard title={title}>
      {ocorrencias.length === 0 ? (
        <h5>Não Existe Ocorrências</h5>
      ) : (
        <div style={{ height: 130 }}>
          <ResponsiveContainer height={150} width="100%">
            <PieChart>
              <Pie data={ocorrencias} innerRadius={40} outerRadius={60} paddingAngle={5}>
                {ocorrencias.map((entry, index) => (
                  <Cell key={index} fill={COLORS[index % COLORS.length]} />
                ))}
              </Pie>
              <Legend verticalAlign="center" layout="vertical" align="right" height={36} />
              <Tooltip />
            </PieChart>
          </ResponsiveContainer>
        </div>
      )}
    </CustomCard>
  )
}

const DatatableEquipe = ({ title, equipeColumnTitle, equipeData }) => {
  // Render
  return (
    <>
      <PageHeader>{title}</PageHeader>
      <div style={{ marginTop: 16 }}>
        <DataTable value={equipeData} emptyMessage="Ocorrências Não encontradas">
          <Column field={'nome'} header={equipeColumnTitle} />
          <Column field={'qteCaixas'} header={'Qte Caixas'} style={tableCellCentered(80)} />
          <Column
            field={'ocorrenciasSeparacao'}
            header={'Etapa Separação'}
            style={tableCellCentered(100)}
          />
          <Column
            field={'ocorrenciasEntrega'}
            header={'Etapa Entrega'}
            style={tableCellCentered(100)}
          />
          <Column field={'indice'} header={'% Ocorrência'} style={tableCellCentered(100)} />
        </DataTable>
      </div>
    </>
  )
}

const mapStateToProps = ({ system: { selectedTp } }) => ({ selectedTp })
export default connect(mapStateToProps)(withRouter(OcorrenciasPorColaboradores))
